import DashboardContent from "./DashboardContent/DashboardContent";
import Favorites from "./Favorites/Favorites";
import DashboardNavItem from "./DashboardNavItem/DashboardNavItem";
import { useEffect, useState } from "react";
import Profile from "./Profile/Profile";
import DonorList from "./DonorList/DonorList";
import { Link, useNavigate } from "react-router-dom";
import { dashboard } from "../../api/Dashboard";
import AddMemberModal from "./AddMemberModal/AddMemberModal";
import MemberList from "./MemberList/MemberList";
import FosterList from "./FosterList/FosterList";
import Resources from "./Resources/Resources";
import NonprofitDonationList from "./NonprofitDonationList/NonprofitDonationList";
import UserDonationList from "./UserDonationList/UserDonationList";
import NonprofitProfile from "./NonprofitProfile/NonprofitProfile";
import Subscription from "./Subscription/Subscription";
// import OrdersPage from "./Orders/OrdersPage"; // Commented out - shop feature disabled
import ContactModal from "./ContactModal/ContactModal";
import dashboardClasses from "./Dashboard.module.css";
import NotFound from "../shared/Utils/NotFound";
import FosterInterest from "./FosterInterest/FosterInterest";
import PetStarTab from "./PetStarTab/PetStarTab";
import AffiliateDashboard from "./Affiliates/AffiliateDashboard/AffiliateDashboard";
import { useDispatch, useSelector } from "react-redux";
import { userDataActions } from "../../store";
import ConnectBankAccount from "./ConnectBackAccount/ConnectBankAccount";
import { useMediaQuery } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faBook,
  faChartPie,
  faCircleInfo,
  faClipboardUser,
  faComments,
  faFolderClosed,
  faIdCardClip,
  faUser,
  faUsers,
  faHeart,
  faDesktop,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import DashboardHeader from "./DashboardHeader/DashboardHeader";
import Spinner from "../shared/LoadingSpinner/Spinner";
import NonprofitSubscription from "./NonprofitSubscription/NonprofitSubscription";
import OnboardingChecklist from "./OnboardingChecklist/OnboardingChecklist";
import NonprofitCreate from "./NonprofitCreate/NonprofitCreate";
import { getNpInfo } from "../../api/NonprofitInfo";
import { getTotalCampaigns } from "../../api/Campaigns";
import { getDonors } from "../../api/GetDonors";
import ArticlesAndVideos from "./Resources/ArticlesAndVideos";
import ResourceSubTab from "./Resources/ResourceSubTab";
import CampaignModal from "./CampaignModal/CampaignModal";
import QRCodeModal from "./QRCodeModal/QRCodeModal";
import CampaignDetailsPage from "./CampaignDetailsPage/CampaignDetailsPage";

export const DASHBOARD_MODALS = {
  addMember: "Add Member",
};

function Dashboard() {
  const [tab, setTab] = useState("");
  const [localUserData, setLocalUserData] = useState(null);
  const [npIsApproved, setNpIsApproved] = useState(null);
  const [npStripeEnabled, setNpStripeEnabled] = useState(false);
  const [npOrgName, setNpOrgName] = useState("");
  const [npCampaignCreated, setNpCampaignCreated] = useState(false);
  const [npDonorListUploaded, setNpDonorListUploaded] = useState(false);
  const [npEmailStepCompleted, setNpEmailStepCompleted] = useState(false);
  const [showDashboardContent, setShowDashboardContent] = useState(false);
  const [campaignDetailData, setCampaignDetailData] = useState(null);
  const [campaignUrl, setCampaignUrl] = useState("");
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [modal, setModal] = useState("");
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [nonprofitProfileOpen, setNonprofitProfileOpen] = useState(false);
  // const [orders, setOrders] = useState(false); // Commented out - shop feature disabled
  const [openContact, setOpenContact] = useState(false);
  const userData = useSelector((state) => state.userData.userData);
  const dispatch = useDispatch();

  const matchesMin853px = useMediaQuery("(max-width: 853px)");
  const navigate = useNavigate();

  const contactUs = () => {
    if (matchesMin853px) {
      if (tab === "Help") {
        if (localUserData["user_type"] === "nonprofit_admin") {
          setTab("Dashboard");
        } else if (localUserData["user_type"] === "nonprofit_member") {
          setTab("User Profile");
        } else if (localUserData["user_type"] === "regular_user") {
          setTab("User Profile");
        } else if (localUserData["user_type"] === "affiliate") {
          setTab("Affiliate Dashboard");
        }
      } else {
        setTab("Help");
      }
    } else {
      setOpenContact((prev) => !prev);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [tab]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDataString = localStorage.getItem("userData");

        if (userDataString) {
          const userDataParsed = JSON.parse(userDataString);
          const response = await dashboard(userDataParsed.id);

          dispatch(userDataActions.updateUserData(JSON.stringify(response)));
          setLocalUserData(response);

          if (response.user_type === "nonprofit_admin") {
            setTab("Dashboard");
            if (response.nonprofit) {
              try {
                const npData = await getNpInfo(response.nonprofit);
                setNpIsApproved(npData.is_approved);
                setNpStripeEnabled(!!npData.stripe_account?.charges_enabled);
                setNpOrgName(npData.org_name || "");
                try {
                  const total = await getTotalCampaigns(response.nonprofit);
                  if (total?.total_campaigns > 0) setNpCampaignCreated(true);
                } catch (e) { /* non-critical */ }
                try {
                  const donors = await getDonors(response.nonprofit);
                  const list = Array.isArray(donors) ? donors : donors?.results || [];
                  if (list.length > 0) setNpDonorListUploaded(true);
                } catch (e) { /* non-critical */ }
                if (localStorage.getItem(`emailStep_${response.nonprofit}`) === "completed") {
                  setNpEmailStepCompleted(true);
                  setShowDashboardContent(true);
                }
              } catch (e) {
                setNpIsApproved(false);
              }
            }
          } else if (response.user_type === "nonprofit_member") {
            setTab("Dashboard");
            if (response.nonprofit) {
              try {
                const npData = await getNpInfo(response.nonprofit);
                setNpIsApproved(npData.is_approved);
                setNpStripeEnabled(!!npData.stripe_account?.charges_enabled);
                setNpOrgName(npData.org_name || "");
                try {
                  const total = await getTotalCampaigns(response.nonprofit);
                  if (total?.total_campaigns > 0) setNpCampaignCreated(true);
                } catch (e) { /* non-critical */ }
                try {
                  const donors = await getDonors(response.nonprofit);
                  const list = Array.isArray(donors) ? donors : donors?.results || [];
                  if (list.length > 0) setNpDonorListUploaded(true);
                } catch (e) { /* non-critical */ }
                if (localStorage.getItem(`emailStep_${response.nonprofit}`) === "completed") {
                  setNpEmailStepCompleted(true);
                  setShowDashboardContent(true);
                }
              } catch (e) {
                setNpIsApproved(false);
              }
            }
          } else if (response.user_type === "regular_user") {
            setTab("User Profile");
          } else if (response.user_type === "affiliate") {
            setTab("Affiliate Dashboard");
          }
          localStorage.setItem("userData", JSON.stringify(response));

          // setOrders(response?.orders || false); // Commented out - shop feature disabled
        } else {
          // Clear the localStorage items if they are corrupted or on error
          localStorage.removeItem("userData");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("accessToken");

          if (!userData || Object.keys(userData).length !== 0) {
            dispatch(userDataActions.removeUserData());
          }

          setLocalUserData(null);
          navigate("/");
        }
      } catch (error) {
        console.error(
          "Failed to parse user data or fetch user profile: ",
          error
        );
        // Clear the localStorage items if they are corrupted or on error
        localStorage.removeItem("userData");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("accessToken");

        if (!userData || Object.keys(userData).length !== 0) {
          dispatch(userDataActions.removeUserData());
        }

        setLocalUserData(null);
        navigate("/login");
      }
    };
    fetchUserData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, navigate]);

  const hideModals = () => {
    setModal("");
  };

  const pendingApprovalCheck =
    (localUserData?.user_type === "nonprofit_member" ||
      localUserData?.user_type === "nonprofit_admin") &&
    localUserData?.nonprofit &&
    npIsApproved === null;

  if (!localUserData || pendingApprovalCheck) {
    return (
      <div className="flex flex-row ml-auto mt-[25vh] w-full h-full justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    //App.css
    <div className="App">
      {openContact && <ContactModal closeModal={contactUs} />}

      <div
        className={`${dashboardClasses.nav_container} mt-[102px] flex flex-start lg:flex-row flex-col mx-0 mb-0 w-full`}
      >
        {localUserData &&
          (localUserData.user_type === "regular_user" ? (
            <>
              <DashboardHeader
                alltabs={[
                  "Favorites",
                  localUserData &&
                  ((localUserData.donations_details &&
                    localUserData.donations_details.length > 0) ||
                    (localUserData.general_donations_details &&
                      localUserData.general_donations_details.length > 0))
                    ? "Your Donations"
                    : "",
                  "User Profile",
                  localUserData.petstar_sub === true ? "Petstar" : "",
                  localUserData.np_subscriptions &&
                  localUserData.np_subscriptions.length > 0
                    ? "Nonprofit Subscriptions"
                    : "",
                  // orders ? "Orders" : "", // Commented out - shop feature disabled
                  "Help",
                ]}
                currentTab={tab}
                setTab={setTab}
              />
              <div className={`${dashboardClasses.dashboard_nav} flex flex-col items-start justify-start pt-8 w-[263px] min-h-screen bg-blue self-stretch`}>
                <p className="text-white !font-poppins !font-semibold !text-[22px] mb-6 px-6 text-left">Overview</p>
                {[
                  { label: "Favorites", icon: faHeart },
                  { label: "User Profile", icon: faUser },
                  ...(localUserData.donations_details?.length > 0 || localUserData.general_donations_details?.length > 0 ? [{ label: "Your Donations", icon: faIdCardClip }] : []),
                  ...(localUserData.petstar_sub === true ? [{ label: "PetStar", icon: faChartPie }] : []),
                  ...(localUserData.np_subscriptions?.length > 0 && localUserData.np_subscriptions.some(s => s.active) ? [{ label: "Nonprofit Subscriptions", icon: faFolderClosed }] : []),
                  { label: "Foster Interest Form", icon: faClipboardUser },
                ].map(({ label, icon }) => (
                  <div
                    key={label}
                    onClick={() => setTab(label)}
                    className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${
                      tab === label ? "bg-blue-navy" : "hover:bg-blue-navy"
                    }`}
                  >
                    <FontAwesomeIcon icon={icon} size="sm" />
                    <span className="flex-1 text-left">{label}</span>
                  </div>
                ))}
                <div
                  onClick={contactUs}
                  className="flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 !font-montserrat !font-normal !text-[14px] text-white hover:bg-blue-navy w-[calc(100%-16px)]"
                >
                  <FontAwesomeIcon icon={faCircleInfo} size="sm" />
                  <span className="text-left">Help</span>
                </div>
              </div>
            </>
          ) : localUserData.user_type === "nonprofit_member" &&
            !localUserData.nonprofit ? (
            <>
              <DashboardHeader
                alltabs={["Dashboard", "Help"]}
                currentTab={tab}
                setTab={setTab}
              />
              <div
                className={`${dashboardClasses.dashboard_nav} flex flex-col items-start justify-start pt-8 w-[263px] min-h-screen bg-blue self-stretch`}
              >
                <p className="text-white !font-poppins !font-semibold !text-[22px] mb-6 px-6 text-left">Overview</p>
                <div
                  onClick={() => setTab("Dashboard")}
                  className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${
                    tab === "Dashboard" || tab === "Create Nonprofit" ? "bg-blue-navy" : "hover:bg-blue-navy"
                  }`}
                >
                  <FontAwesomeIcon icon={faDesktop} size="lg" />
                  <span className="text-left">Dashboard</span>
                </div>
                <div
                  onClick={contactUs}
                  className="flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 !font-montserrat !font-normal !text-[14px] text-white hover:bg-blue-navy w-[calc(100%-16px)]"
                >
                  <FontAwesomeIcon icon={faCircleInfo} size="lg" />
                  <span className="text-left">Help</span>
                </div>
              </div>
            </>
          ) : (localUserData.user_type === "nonprofit_member" ||
            localUserData.user_type === "nonprofit_admin") &&
            localUserData.nonprofit &&
            (npIsApproved === false || (npIsApproved === true && !npStripeEnabled)) ? (
            <>
              <DashboardHeader
                alltabs={["Dashboard", "Nonprofit Profile", "Resources", "Help"]}
                currentTab={tab}
                setTab={setTab}
              />
              <div
                className={`${dashboardClasses.dashboard_nav} flex flex-col items-start justify-start pt-8 w-[263px] min-h-screen bg-blue self-stretch`}
              >
                <p className="text-white !font-poppins !font-semibold !text-[22px] mb-6 px-6 text-left">Overview</p>
                {[
                  { label: "Dashboard", icon: faDesktop },
                  { label: "Nonprofit Profile", icon: faClipboardUser },
                ].map(({ label, icon }) => (
                  <div
                    key={label}
                    onClick={() => { setTab(label); setResourcesOpen(false); }}
                    className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${
                      tab === label ? "bg-blue-navy" : "hover:bg-blue-navy"
                    }`}
                  >
                    <FontAwesomeIcon icon={icon} size="sm" />
                    <span className="flex-1 text-left">{label}</span>
                  </div>
                ))}
                {/* Resources accordion */}
                <div className="w-[calc(100%-16px)] mx-2 mb-2">
                  <div
                    onClick={() => {
                      setResourcesOpen((prev) => !prev);
                      setTab("Articles & Videos");
                    }}
                    className={`flex items-center gap-4 cursor-pointer rounded-xl px-4 py-4 !font-montserrat !font-normal !text-[14px] text-white w-full ${
                      ["Articles & Videos", "Checklists", "Emails", "Guides", "Letters", "Templates", "Worksheets"].includes(tab) ? "bg-blue-navy" : "hover:bg-blue-navy"
                    }`}
                  >
                    <FontAwesomeIcon icon={faBook} size="sm" />
                    <span className="flex-1 text-left">Resources</span>
                    <FontAwesomeIcon icon={faChevronDown} size="xs" className={`transition-transform duration-200 ${resourcesOpen ? "rotate-180" : ""}`} />
                  </div>
                  {resourcesOpen && (
                    <div className="flex flex-col mt-1 pl-4">
                      {["Articles & Videos", "Checklists", "Emails", "Guides", "Letters", "Templates", "Worksheets"].map((sub) => (
                        <div
                          key={sub}
                          onClick={() => setTab(sub)}
                          className="cursor-pointer px-4 py-3 !font-montserrat !font-normal !text-[14px] text-white hover:text-white/70 text-left"
                        >
                          {sub}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div
                  onClick={() => { setResourcesOpen(false); contactUs(); }}
                  className="flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 !font-montserrat !font-normal !text-[14px] text-white hover:bg-blue-navy w-[calc(100%-16px)]"
                >
                  <FontAwesomeIcon icon={faCircleInfo} size="sm" />
                  Help
                </div>
              </div>
            </>
          ) : (localUserData.user_type === "nonprofit_member" ||
              localUserData.user_type === "nonprofit_admin") &&
            localUserData.nonprofit ? (
            <>
              <DashboardHeader
                alltabs={[
                  "Dashboard",
                  "Donor List",
                  "Nonprofit Profile",
                  "Donations",
                  localUserData?.donations_details?.length > 0 ? "Your Donations" : "",
                  "Team Members",
                  "Fosters",
                  "User Profile",
                  "Resources",
                  "Help",
                ]}
                currentTab={tab}
                setTab={setTab}
              />
              <div className={`${dashboardClasses.dashboard_nav} flex flex-col items-start justify-start pt-8 w-[263px] min-h-screen bg-blue self-stretch`}>
                <p className="text-white !font-poppins !font-semibold !text-[22px] mb-6 px-6 text-left">Overview</p>

                {/* Dashboard */}
                <div
                  onClick={() => { setTab("Dashboard"); setResourcesOpen(false); setNonprofitProfileOpen(false); }}
                  className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${tab === "Dashboard" ? "bg-blue-navy" : "hover:bg-blue-navy"}`}
                >
                  <FontAwesomeIcon icon={faDesktop} size="sm" />
                  <span className="flex-1 text-left">Dashboard</span>
                </div>

                {/* Donor List */}
                <div
                  onClick={() => { setTab("Donor List"); setResourcesOpen(false); setNonprofitProfileOpen(false); }}
                  className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${tab === "Donor List" ? "bg-blue-navy" : "hover:bg-blue-navy"}`}
                >
                  <FontAwesomeIcon icon={faFolderClosed} size="sm" />
                  <span className="flex-1 text-left">Donor List</span>
                </div>

                {/* Nonprofit Profile accordion */}
                <div className="w-[calc(100%-16px)] mx-2">
                  <div
                    onClick={() => { setTab("Nonprofit Profile"); setNonprofitProfileOpen(!nonprofitProfileOpen); setResourcesOpen(false); }}
                    className={`flex items-center gap-4 cursor-pointer rounded-xl px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-full ${
                      nonprofitProfileOpen || ["Nonprofit Profile","Team Members","User Profile"].includes(tab) ? "bg-blue-navy" : "hover:bg-blue-navy"
                    }`}
                  >
                    <FontAwesomeIcon icon={faClipboardUser} size="sm" />
                    <span className="flex-1 text-left">Nonprofit Profile</span>
                    <FontAwesomeIcon icon={faChevronDown} size="xs" className={`transition-transform ${nonprofitProfileOpen ? "rotate-180" : ""}`} />
                  </div>
                  {nonprofitProfileOpen && (
                    <div className="flex flex-col pl-8 mb-2">
                      {["Team Members", "User Profile"].map((label) => (
                        <div
                          key={label}
                          onClick={() => { setTab(label); }}
                          className={`cursor-pointer py-2 px-3 rounded-lg !text-[13px] !font-montserrat !font-normal mb-1 text-left ${
                            tab === label ? "text-blue-navy font-semibold" : "text-white hover:text-blue-navy"
                          }`}
                        >
                          {label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Donations */}
                <div
                  onClick={() => { setTab("Donations"); setResourcesOpen(false); setNonprofitProfileOpen(false); }}
                  className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${tab === "Donations" ? "bg-blue-navy" : "hover:bg-blue-navy"}`}
                >
                  <FontAwesomeIcon icon={faIdCardClip} size="sm" />
                  <span className="flex-1 text-left">Donations</span>
                </div>

                {/* Your Donations (conditional) */}
                {localUserData?.donations_details?.length > 0 && (
                  <div
                    onClick={() => { setTab("Your Donations"); setResourcesOpen(false); setNonprofitProfileOpen(false); }}
                    className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${tab === "Your Donations" ? "bg-blue-navy" : "hover:bg-blue-navy"}`}
                  >
                    <FontAwesomeIcon icon={faFolderClosed} size="sm" />
                    <span className="flex-1 text-left">Your Donations</span>
                  </div>
                )}

                {/* Fosters */}
                <div
                  onClick={() => { setTab("Fosters"); setResourcesOpen(false); setNonprofitProfileOpen(false); }}
                  className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${tab === "Fosters" ? "bg-blue-navy" : "hover:bg-blue-navy"}`}
                >
                  <FontAwesomeIcon icon={faUser} size="sm" />
                  <span className="flex-1 text-left">Fosters</span>
                </div>

                {/* Resources accordion */}
                <div className="w-[calc(100%-16px)] mx-2">
                  <div
                    onClick={() => { setTab("Articles & Videos"); setResourcesOpen(!resourcesOpen); setNonprofitProfileOpen(false); }}
                    className={`flex items-center gap-4 cursor-pointer rounded-xl px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-full ${
                      resourcesOpen || ["Articles & Videos","Templates","Checklists","Emails","Guides","Letters","Worksheets"].includes(tab) ? "bg-blue-navy" : "hover:bg-blue-navy"
                    }`}
                  >
                    <FontAwesomeIcon icon={faComments} size="sm" />
                    <span className="flex-1 text-left">Resources</span>
                    <FontAwesomeIcon icon={faChevronDown} size="xs" className={`transition-transform ${resourcesOpen ? "rotate-180" : ""}`} />
                  </div>
                  {resourcesOpen && (
                    <div className="flex flex-col pl-8 mb-2">
                      {["Articles & Videos","Templates","Checklists","Emails","Guides","Letters","Worksheets"].map((label) => (
                        <div
                          key={label}
                          onClick={() => setTab(label)}
                          className={`cursor-pointer py-2 px-3 rounded-lg !text-[13px] !font-montserrat !font-normal mb-1 text-left ${
                            tab === label ? "text-blue-navy font-semibold" : "text-white hover:text-blue-navy"
                          }`}
                        >
                          {label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Help */}
                <div
                  onClick={() => { setResourcesOpen(false); setNonprofitProfileOpen(false); contactUs(); }}
                  className="flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 !font-montserrat !font-normal !text-[14px] text-white hover:bg-blue-navy w-[calc(100%-16px)]"
                >
                  <FontAwesomeIcon icon={faCircleInfo} size="sm" />
                  <span className="text-left">Help</span>
                </div>
              </div>
            </>
          ) : localUserData.user_type === "affiliate" ? (
            <>
              <DashboardHeader
                alltabs={[
                  "Affiliate Dashboard",
                  "Your Monthly Donation",
                  "Connect Bank Account",
                  "User Profile",
                ]}
                currentTab={tab}
                setTab={setTab}
              />
              <div className={`${dashboardClasses.dashboard_nav} flex flex-col items-start justify-start pt-8 w-[263px] min-h-screen bg-blue self-stretch`}>
                <p className="text-white !font-poppins !font-semibold !text-[22px] mb-6 px-6 text-left">Overview</p>
                {[
                  { label: "Affiliate Dashboard", icon: faChartPie },
                  { label: "Your Monthly Donation", icon: faIdCardClip },
                  { label: "Connect Bank Account", icon: faClipboardUser },
                  { label: "User Profile", icon: faUser },
                ].map(({ label, icon }) => (
                  <div
                    key={label}
                    onClick={() => setTab(label)}
                    className={`flex items-center gap-4 cursor-pointer rounded-xl mx-2 px-4 py-4 mb-2 !font-montserrat !font-normal !text-[14px] text-white w-[calc(100%-16px)] ${
                      tab === label ? "bg-blue-navy" : "hover:bg-blue-navy"
                    }`}
                  >
                    <FontAwesomeIcon icon={icon} size="sm" />
                    <span className="flex-1 text-left">{label}</span>
                  </div>
                ))}
              </div>
            </>
          ) : null)}

        {tab === "User Profile" ? <Profile /> : ""}
        {tab === "Dashboard" && !localUserData?.nonprofit && <OnboardingChecklist setTab={setTab} />}
        {tab === "Dashboard" && localUserData?.nonprofit && npIsApproved === false && <OnboardingChecklist setTab={setTab} nonprofitCreated={true} />}
        {tab === "Dashboard" && localUserData?.nonprofit && npIsApproved === true && !npStripeEnabled && <OnboardingChecklist setTab={setTab} nonprofitCreated={true} isApproved={true} />}
        {tab === "Dashboard" && localUserData?.nonprofit && npIsApproved === true && npStripeEnabled && showDashboardContent && (
          <DashboardContent
            setTab={setTab}
            onOpenCampaignDetails={(campaign) => {
              setCampaignDetailData(campaign);
              setTab("Campaign Details");
            }}
          />
        )}
        {tab === "Dashboard" && localUserData?.nonprofit && npIsApproved === true && npStripeEnabled && !showDashboardContent && (
          <OnboardingChecklist
            setTab={setTab}
            nonprofitCreated={true}
            isApproved={true}
            stripeConnected={true}
            campaignCreated={npCampaignCreated}
            donorListUploaded={npDonorListUploaded}
            onCreateCampaign={(type) => setTab(type === "Animal" ? "Create Animal Campaign" : "Create Capital Campaign")}
            emailStepCompleted={npEmailStepCompleted}
            onEmailStepComplete={() => {
              setNpEmailStepCompleted(true);
              localStorage.setItem(`emailStep_${localUserData?.nonprofit}`, "completed");
            }}
            onViewDashboard={() => setShowDashboardContent(true)}
          />
        )}
        {tab === "Campaign Details" && campaignDetailData && (
          <CampaignDetailsPage
            campaign={campaignDetailData}
            onBack={() => setTab("Dashboard")}
          />
        )}
        {tab === "Create Nonprofit" && !localUserData?.nonprofit && <NonprofitCreate />}
        {tab === "Donor List" ? <DonorList onUploadSuccess={() => setNpDonorListUploaded(true)} /> : ""}
        {tab === "Team Members" ? <MemberList /> : ""}
        {tab === "Fosters" ? <FosterList /> : ""}
        {tab === "Nonprofit Profile" ? <NonprofitProfile /> : ""}
        {tab === "Resources" ? <Resources /> : ""}
        {tab === "Articles & Videos" ? <ArticlesAndVideos /> : ""}
        {tab === "Templates" && <ResourceSubTab title="Templates" categories={["Templates", "Sheets"]} />}
        {tab === "Checklists" && <ResourceSubTab title="Checklists" categories={["Checklists"]} />}
        {tab === "Emails" && <ResourceSubTab title="Emails" categories={["Emails"]} />}
        {tab === "Guides" && <ResourceSubTab title="Guides" categories={["Guides"]} />}
        {tab === "Letters" && <ResourceSubTab title="Letters" categories={["Letters"]} />}
        {tab === "Worksheets" && <ResourceSubTab title="Worksheets" categories={["Worksheets"]} />}
        {tab === "Favorites" ? <Favorites /> : ""}
        {tab === "Donations" ? <NonprofitDonationList /> : ""}
        {tab === "Your Donations" ? <UserDonationList /> : ""}
        {tab === "PetStar" ? <Subscription /> : ""}
        {tab === "Nonprofit Subscriptions" ? <NonprofitSubscription /> : ""}
        {/* {tab === "Orders" ? <OrdersPage /> : ""} */}{/* Commented out - shop feature disabled */}
        {tab === "Your Monthly Donation" ? <PetStarTab /> : ""}
        {tab === "Help" && matchesMin853px && (
          <ContactModal closeModal={contactUs} />
        )}
        {tab === "Affiliate Dashboard" ? (
          <AffiliateDashboard setTab={setTab} />
        ) : (
          ""
        )}
        {tab === "Connect Bank Account" ? <ConnectBankAccount /> : ""}

        {modal === DASHBOARD_MODALS.addMember ? (
          <AddMemberModal close={hideModals} />
        ) : (
          ""
        )}

        {tab === "Create Animal Campaign" && (
          <CampaignModal
            isOpen={true}
            inline={true}
            nonprofitId={localUserData?.nonprofit}
            nonprofitName={npOrgName}
            setCampaigns={() => { setNpCampaignCreated(true); setTab("Dashboard"); }}
            setQrModalOpen={setQrModalOpen}
            campaignUrl={campaignUrl}
            setCampaignUrl={setCampaignUrl}
            campaignType="Animal"
          />
        )}
        {tab === "Create Capital Campaign" && (
          <CampaignModal
            isOpen={true}
            inline={true}
            nonprofitId={localUserData?.nonprofit}
            nonprofitName={npOrgName}
            setCampaigns={() => { setNpCampaignCreated(true); setTab("Dashboard"); }}
            setQrModalOpen={setQrModalOpen}
            campaignUrl={campaignUrl}
            setCampaignUrl={setCampaignUrl}
            campaignType="Capital"
          />
        )}
        {qrModalOpen && (
          <QRCodeModal
            isOpen={qrModalOpen}
            onClose={() => { setQrModalOpen(false); setCampaignUrl(""); }}
            campaignUrl={campaignUrl}
          />
        )}
      </div>
    </div>
  );
}

export default Dashboard;
